import { DAPI_HOST } from '../../config';

const getGroupUrl = (groupId: string) => `${DAPI_HOST}/v1/groups/${groupId}`;

export { getGroupUrl };
